import { toast } from "react-toastify";
import { store } from './store';
import fetch from 'isomorphic-fetch';

let sessionToastShowed;

export const apiFetch = function(url, options) {
  const absoluteUrl = process.env.REACT_APP_API_URL;
  const fullUrl = `${absoluteUrl}${url}`;
  const {auth} = store.getState();

  options.headers = {...options.headers, Authorization: `Bearer ${auth.token}`};

  return fetch(fullUrl, options).then(response => {
    if (auth.token && response.status === 401) {
      store.dispatch({
        type: 'AUTH_SIGNOUT_SUCCESS',
      });
      if (!sessionToastShowed) {
        sessionToastShowed = true;
        toast.success("Your session has expired.");
      }
      return Promise.reject('Unauthorized');
    }
    sessionToastShowed = false;
    if (options.rawResponse) {
      return response;
    }
    return parseApiResponse(response);
  });
};

export function parseApiResponse(response) {
  const json = response.json();

  if (response.ok && (response.status >= 200 && response.status < 300)) {
    return json;
  }

  return json.then(err => Promise.reject(err));
}




// WEBPACK FOOTER //
// ./src/apiFetch.js